import { Fragment } from 'react';
import { CaretRight } from '@hungryroot/icons';
import { Text, Heading } from '@hungryroot/ramen';
import styles from './Breadcrumb.module.css';

const breadcrumbs = ['About you', 'Claim Offer', 'Checkout'] as const;

const { length: breadcrumbsLength } = breadcrumbs;

type Breadcrumbs = (typeof breadcrumbs)[number];

type Props = {
  selected: Breadcrumbs;
};

export function Breadcrumb({ selected }: Props) {
  const activeIndex = breadcrumbs.indexOf(selected);
  return (
    <nav aria-label="Breadcrumb">
      <ol className={styles.container}>
        {breadcrumbs.map((label, index) => {
          const isActive = label === selected;
          return (
            <Fragment key={label}>
              {isActive === true ? (
                <li aria-current="step">
                  <Heading className={styles.active} variant="H6">
                    {label}
                  </Heading>
                </li>
              ) : (
                <li>
                  <Text className={index > activeIndex ? styles.future : ''}>
                    {label}
                  </Text>
                </li>
              )}
              {index !== breadcrumbsLength - 1 && (
                <li aria-hidden="true" className={styles.caret}>
                  <CaretRight />
                </li>
              )}
            </Fragment>
          );
        })}
      </ol>
    </nav>
  );
}
